import api from "./api";
import {mapEmployeeProjectsDto} from "../dto/EmployeeProjectsDto";


export const createEmployeeProjectForUser = async (userId, dto) => {
    try {
        const res = await api.post(`/EmployeeProject/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error creating EmployeeProject:", err);
        throw err;
    }
};

export async function updateEmployeeProject(projectId, dto) {
    const payload = {
        title: dto.title,
        industry: dto.industry,
        start_date: dto.start_date,
        end_date: dto.end_date,
        skills: dto.skills,
        description: dto.description,
        sort_order: dto.sort_order,
    };

    return api.patch(`/EmployeeProject/${projectId}`, payload, {
        headers: {"Content-Type": "application/json"},
    });
}

export const deleteEmployeeProject = async (userId) => {
    try {
        const res = await api.delete(`/EmployeeProject/${userId}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting Holiday:", err);
        throw err;
    }
};


export const getEmployeeProjectsForUser = async (userId) => {
    try {
        const url = `/EmployeeProject/${userId}`;
        const res = await api.get(url);
        return res.data.map(mapEmployeeProjectsDto);
    } catch (err) {
        console.error("Error getting employee project for User:", err);
        throw err;
    }
};
